import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import Data from '../../../../components/Display/Data';
import MultiLineData from '../../../../components/Display/MultiLineData';
import MultipleDataTag from '../../../../components/Display/MultipleDataTag';
import Section from '../../../../components/Display/Section';
import { getConstant } from '../../../../utils/constants';
import ImageItem from '../../common/image/ImageItem';
import ReviewListItem from './Review/ReviewListItem';
import styles from "../../../../components/Display/Wrapper.module.scss";
import { Star } from 'lucide-react';


function ProjectDetail({
  project,
  handleUpdateProject,
  handleUpdateImages,
  handleDelete,
  handleCreateReview,
  handleDeleteReview,
  handleUpdateReview
}) {
  const updateProjectActions = [
    {
      onClick: handleUpdateProject,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const updateImagesActions = [
    {
      onClick: handleUpdateImages,
      label: 'Modifier les images',
      icon: 'pi-pencil'
    }
  ];

  const addReviewActions = [
    {
      onClick: handleCreateReview,
      label: 'Ajouter un avis',
      icon: 'pi-plus'
    }
  ];

  const confirmReviewDeletion = (review) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette review ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDeleteReview(review)
    });
  };

  const confirmDeletion = (project) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce Projet ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(project)
    });
  };



  return (
    <div className={styles.scrollableSectionContainer}>
      <Section label="Informations générales" actions={updateProjectActions}>
        <MultipleDataTag
          key="status"
          label={'Statuts'}
          tags={[
            getConstant('collectifnode.inProgress', project.in_progress),
            project.is_highlight && {
              label: 'Projet mis en avant',
              icon: Star,
              bgColor: 'bg-purple-800'
            }
          ]}
          rounded
        />
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={project.title} large />
          <Data
            key="type"
            label={'Types'}
            value={project.properties
              .filter((property) => property.type === 'cn_project_type')
              .map((property) => property.label)
              .join(', ')}
            large
          />
          <Data
            key="client_type"
            label={'Type de Client'}
            value={project.client_type}
            disabled={!project.is_highlight}
          />
          <Data key="year" label={'Année'} value={project.year} />

        </div>
        <div className="flex flex-wrap gap-5">
          <Data key="website_url" label={'Url du site'} value={project.website_url} large />

          <Data
            key="eco_rating_url"
            label={'Carbon Url'}
            value={project.eco_rating_url}
            disabled={!project.is_highlight}
            large
          />
          <Data
            key="eco_rating"
            label={'Note Carbon'}
            value={`${project.eco_rating ? `${project.eco_rating} %` : ''}`}
            disabled={!project.is_highlight}
          />


        </div>
        <div className="flex flex-col gap-5">
          <MultipleDataTag
            key="technologies"
            label={'Technologies utilisées'}
            tags={project.properties.filter((property) => property.type === 'cn_technology')}
            disabled={!project.is_highlight}
          />
          <MultipleDataTag
            key="expertises"
            label={'Expertises'}
            tags={project.properties.filter((property) => property.type === 'cn_skill')}
            disabled={!project.is_highlight}
          />
        </div>
        <div className="flex gap-5">
          <MultiLineData key="resume" label={'Résumé'} value={project.resume} large asHtml />
          <MultiLineData
            key="description"
            label={'Description'}
            value={project.description}
            large
            asHtml
          />
        </div>
      </Section>

      <Section label="Image principale">
        {!project.responsive_main_image ? (
          <span className="italic text-slate-400 font-light">Aucune image à afficher</span>
        ) : (
          <ImageItem
            image={project.responsive_main_image}
            alt={`Photo de ${project.title}`}
            className="h-60 w-fit"
          />
        )}
      </Section>

      <Section label="Avis client" actions={addReviewActions}>
        <div className={`${styles.gridLayout}`}>
          {project.reviews.map((review, index) => (
            <ReviewListItem
              key={index}
              review={review}
              deleteReview={confirmReviewDeletion}
              updateReview={handleUpdateReview}
            />))}
        </div>
      </Section>

      {project.is_highlight && (
        <Section label="Images secondaires" actions={updateImagesActions}>
          <div className={`flex flex-wrap gap-3`}>
            {!project.responsive_images.length ? (
              <span className="italic text-slate-400 font-light">Aucune image à afficher</span>
            ) : (
              project.responsive_images.map((img, index) => (
                <ImageItem
                  key={index}
                  image={img}
                  alt={`Photo de ${project.title} n°${index}`}
                  className="h-60"
                />
              ))
            )}
          </div>
        </Section>
      )}

      <Section label="Autres actions">
        <div>
          <Button
            key={'delete'}
            label={'Supprimer le projet'}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(project)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default ProjectDetail;
